import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";

@Directive({
	selector: '[lb-events]',
	
})
export class AngularElementEventDirective implements OnInit, AfterViewInit, OnDestroy {
	
	@Output() onInit = new EventEmitter<HTMLElement>();
	@Output() afterViewInit = new EventEmitter<HTMLElement>();
	@Output() onDestroy =  new EventEmitter<HTMLElement>();
	
	constructor(
		private elRef: ElementRef
	) {}
	
	ngOnInit(): void {
		this.onInit.emit(this.elRef.nativeElement);
	}
	
	ngAfterViewInit(): void {
		this.afterViewInit.emit(this.elRef.nativeElement);
	}
	
	ngOnDestroy(): void {
		this.onDestroy.emit(this.elRef.nativeElement);
	}
}